const SCROLLBAR_VISIBLE_DURATION = 700
const hideTimers = new WeakMap<HTMLElement, number>()

function resolveScrollElement(target: EventTarget | null): HTMLElement {
  return target instanceof HTMLElement ? target : document.documentElement
}

export function installScrollbarVisibility(): void {
  document.addEventListener(
    'scroll',
    event => {
      const element = resolveScrollElement(event.target)
      const previousTimer = hideTimers.get(element)

      if (previousTimer !== undefined) {
        window.clearTimeout(previousTimer)
      }

      element.classList.add('is-scrolling')
      const timer = window.setTimeout(() => {
        element.classList.remove('is-scrolling')
        hideTimers.delete(element)
      }, SCROLLBAR_VISIBLE_DURATION)

      hideTimers.set(element, timer)
    },
    { capture: true, passive: true },
  )
}
